import { FieldValidator } from '../../models/FieldValidator.model';
import { TypeDefinitionStr } from '../../models/TypeDefinition.model';
import { ValidationRules } from '../../models/ValidationRuleNames.model';

import { createMaxLengthValidator } from './maxLength.validator';
import { createMinLengthValidator } from './minLength.validator';

export function createStrValidators(
    fieldName: string, typeDef: TypeDefinitionStr, customMessages?: Record<ValidationRules, string>,
): FieldValidator[] {
    const validators: FieldValidator[] = [];

    if (typeDef.minLength != null) {
        validators.push({
            name: 'str.minLength',
            validate: createMinLengthValidator(
                typeDef.minLength, { fieldName, customMsg: customMessages?.['str.minLength'] },
            ),
        });
    }
    if (typeDef.maxLength != null) {
        validators.push({
            name: 'str.maxLength',
            validate: createMaxLengthValidator(
                typeDef.maxLength, { fieldName, customMsg: customMessages?.['str.maxLength'] },
            ),
        });
    }
    return validators;
}
